import { render, staticRenderFns } from "./EscalateModal.vue?vue&type=template&id=c6e9f7a8&scoped=true&"
import script from "./EscalateModal.vue?vue&type=script&lang=js&"
export * from "./EscalateModal.vue?vue&type=script&lang=js&"
import style0 from "./EscalateModal.vue?vue&type=style&index=0&id=c6e9f7a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e9f7a8",
  null
  
)

export default component.exports